export const Skeleton = () => {

    return (
        <div className="card is-loading">
            <div className="container-pill">
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
            </div>

            <div className="container-pill">
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
            </div>

            <div className="container-pill">
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
                <div className="pill"></div>
            </div>
        </div>
    )
}